<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-job-profile',
};
</script>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/page-profiles.vue